import { create } from 'zustand';

export type ThemeMode = 'light' | 'dark';

interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
  setMode: (mode: ThemeMode) => void;
}

const THEME_KEY = 'agrovid_theme';

function readMode(): ThemeMode {
  try {
    const v = localStorage.getItem(THEME_KEY);
    if (v === 'dark') return 'dark';
  } catch { /* ignore */ }
  return 'light';
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  mode: readMode(),
  toggle: () => {
    const next: ThemeMode = get().mode === 'light' ? 'dark' : 'light';
    try { localStorage.setItem(THEME_KEY, next); } catch { /* ignore */ }
    set({ mode: next });
  },
  setMode: (mode: ThemeMode) => {
    try { localStorage.setItem(THEME_KEY, mode); } catch { /* ignore */ }
    set({ mode });
  },
}));
